import { DropdownContent } from '@fiverr-private/dropdown';

export default DropdownContent;
